(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureController', EditorStructureController);

    EditorStructureController.$inject = ['$scope', '$stateParams', '$uibModal'];

    function EditorStructureController($scope, $stateParams, $uibModal) {
        var vm = this;

        vm.productName = '透明板10cm立牌';
        vm.sku = 'S985001-0001';

        vm.side = 'front';
        vm.sides = [
            { key: 'front', label: '正面图' },
            { key: 'back', label: '反面图' }
        ];

        // TODO: 画布尺寸接入后端后替换为接口数据
        vm.canvasSize = { width: '74mm', height: '84mm' };

        // TODO: 工具条仅为占位交互，后续接入各工具的具体功能
        var toolIconPath = 'content/images/editor-structure/';
        vm.tools = [
            { key: 'resize', label: '调整尺寸', icon: toolIconPath + 'icon-resize.png' },
            { key: 'image', label: '编辑图片', icon: toolIconPath + 'icon-image.png' },
            { key: 'cutline', label: '编辑刀线', icon: toolIconPath + 'icon-cutline.png' },
            { key: 'component', label: '编辑组件', icon: toolIconPath + 'icon-component.png' },
            { key: 'background', label: '添加背景', icon: toolIconPath + 'icon-background.png' },
            { key: 'whiteink', label: '编辑白墨', icon: toolIconPath + 'icon-whiteink.png' },
            { key: 'stamp', label: '烫金', icon: toolIconPath + 'icon-stamp.png' }
        ];
        vm.activeTool = null;

        // TODO: 示例数据，接入后端后替换为接口数据
        // TODO: 面板尺寸格式与侧边栏 size 不一致，后端落地后统一为同一数据源
        var partImage = 'https://lanhu-oss-2537-2.lanhuapp.com/SketchPng92ad69deeb9d70a378ab3f843466d9416ab6f8a9c954667652a576f51f78678f';
        vm.parts = [
            {
                name: '立牌', size: '70*100 mm', qty: 1, area: 70, areaText: '70.00', image: partImage,
                cutlineWidth: 70, cutlineHeight: 100, physicalWidth: 100, physicalHeight: 70,
                physicalSize: '100*70mm', material: '透明板3.5mm',
                printingMethod: '6色高清UV', stampingMethod: '烫金', cuttingMethod: '激光裁切',
                components: ['穿孔3mm', '插口13*3.5mm']
            },
            {
                name: '底座', size: '35*35 mm', qty: 99, area: 12.25, areaText: '12.25', image: partImage,
                cutlineWidth: 35, cutlineHeight: 35, physicalWidth: 35, physicalHeight: 35,
                physicalSize: '35*35mm', material: '透明板3.5mm',
                printingMethod: '6色高清UV', stampingMethod: '', cuttingMethod: '激光裁切',
                components: ['插口13*3.5mm']
            },
            {
                name: '自定义部件', size: '100*100 mm', qty: 999, area: 100, areaText: '100', image: partImage,
                cutlineWidth: 100, cutlineHeight: 100, physicalWidth: 100, physicalHeight: 100,
                physicalSize: '100*100mm', material: '透明板3.5mm',
                printingMethod: '6色高清UV', stampingMethod: '', cuttingMethod: '',
                components: []
            }
        ];
        vm.parts.forEach(updatePartProcesses);
        vm.activePart = vm.parts[0];

        vm.totalArea = function () {
            var total = vm.parts.reduce(function (sum, part) {
                return sum + part.area;
            }, 0);
            return Math.round(total * 100) / 100;
        };

        // 事件处理方法挂在 $scope 上，模板中直接以函数名调用
        $scope.setSide = function (side) {
            vm.side = side;
        };

        $scope.selectTool = function (tool) {
            // 编辑组件是独立页面，需要有当前部件才能进入
            if (tool.key === 'component') {
                if (vm.activePart) {
                    vm.activeTool = 'component';
                }
                return;
            }
            vm.activeTool = vm.activeTool === tool.key ? null : tool.key;
        };

        $scope.closeComponentEditor = function (result) {
            if (result) {
                vm.activePart.components = result.components;
            }
            vm.activeTool = null;
        };

        $scope.selectPart = function (part) {
            vm.activePart = part;
        };

        $scope.increaseQty = function (part) {
            if (part.qty < 999) {
                part.qty += 1;
            }
        };

        $scope.decreaseQty = function (part) {
            if (part.qty > 1) {
                part.qty -= 1;
            }
        };

        $scope.removePart = function (part) {
            var index = vm.parts.indexOf(part);
            if (index === -1) {
                return;
            }
            var wasActive = vm.activePart === part;
            vm.parts.splice(index, 1);
            if (!vm.parts.length) {
                vm.activePart = null;
            } else if (wasActive || !vm.activePart) {
                vm.activePart = vm.parts[0];
            }
        };

        $scope.openPartSettings = function () {
            var targetPart = vm.activePart;
            if (!targetPart) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-part-settings.html',
                controller: 'EditorStructurePartSettingsController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window',
                resolve: {
                    part: [function () {
                        return targetPart;
                    }]
                }
            }).result.then(function (settings) {
                applyPartSettings(targetPart, settings);
            });
        };

        $scope.openPartSizeSettings = function () {
            var targetPart = vm.activePart;
            if (!targetPart) {
                return;
            }
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-part-size.html',
                controller: 'EditorStructurePartSizeController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window',
                resolve: {
                    part: [function () {
                        return targetPart;
                    }]
                }
            }).result.then(function (size) {
                applyPartSize(targetPart, size);
            });
        };

        $scope.addPart = function () {
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-add-part.html',
                controller: 'EditorStructureAddPartController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window',
                resolve: {
                    defaultName: [function () {
                        return nextPartName();
                    }]
                }
            }).result.then(function (config) {
                if (config.method === 'import') {
                    openAddPartImport(config.name);
                } else {
                    openAddPartSize(config.name);
                }
            });
        };

        function openAddPartImport(name) {
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-add-part-import.html',
                controller: 'EditorStructureAddPartImportController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window editor-structure-modal-window-wide'
            }).result.then(function (images) {
                // TODO: 图片解析/上传接口接入后，改用接口返回的刀线图与尺寸
                // 导入图片暂按正面图宽高比、宽 100mm 初始化部件尺寸
                var front = images.front;
                var width = 100;
                var height = front && front.width > 0
                    ? Math.max(1, Math.round(width * front.height / front.width))
                    : 100;
                addPartRecord({
                    name: name,
                    image: front ? front.url : partImage,
                    cutlineWidth: width,
                    cutlineHeight: height,
                    physicalWidth: width,
                    physicalHeight: height,
                    size: width + '*' + height + ' mm',
                    physicalSize: width + '*' + height + 'mm'
                });
            });
        }

        function openAddPartSize(name) {
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-add-part-size.html',
                controller: 'EditorStructureAddPartSizeController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window'
            }).result.then(function (size) {
                addPartRecord({
                    name: name,
                    image: partImage,
                    cutlineWidth: size.width,
                    cutlineHeight: size.height,
                    physicalWidth: size.width,
                    physicalHeight: size.height,
                    size: size.width + '*' + size.height + ' mm',
                    physicalSize: size.width + '*' + size.height + 'mm'
                });
            });
        }

        function addPartRecord(part) {
            // TODO: 材料/工艺接口落地后，新部件的默认材料与工艺改为接口数据
            part.qty = 1;
            part.material = '透明板3.5mm';
            part.printingMethod = '';
            part.stampingMethod = '';
            part.cuttingMethod = '';
            part.components = [];
            part.area = Math.round(part.physicalWidth * part.physicalHeight) / 100;
            part.areaText = part.area % 1 === 0 ? String(part.area) : part.area.toFixed(2);
            updatePartProcesses(part);
            vm.parts.push(part);
            vm.activePart = part;
        }

        function nextPartName() {
            var index = 1;
            while (vm.parts.some(function (part) {
                return part.name === '名称' + index;
            })) {
                index += 1;
            }
            return '名称' + index;
        }

        function applyPartSize(part, size) {
            part.cutlineWidth = size.cutlineWidth;
            part.cutlineHeight = size.cutlineHeight;
            part.physicalWidth = size.physicalWidth;
            part.physicalHeight = size.physicalHeight;
            part.size = size.cutlineWidth + '*' + size.cutlineHeight + ' mm';
            part.physicalSize = size.physicalWidth + '*' + size.physicalHeight + 'mm';

            var area = Math.round(size.physicalWidth * size.physicalHeight) / 100;
            if (area !== part.area) {
                part.area = area;
                part.areaText = area % 1 === 0 ? String(area) : area.toFixed(2);
            }
        }

        function applyPartSettings(part, settings) {
            part.material = settings.material;
            part.printingMethod = settings.printing;
            part.stampingMethod = settings.stamping;
            part.cuttingMethod = settings.cutting;
            updatePartProcesses(part);
        }

        function updatePartProcesses(part) {
            part.processes = [part.printingMethod, part.stampingMethod, part.cuttingMethod]
                .filter(Boolean)
                .join(',');
        }
    }
})();
